export default __webpack_public_path__ + "static/20-1783575714c8fb853b0c0630cd62d2e8.jpg";